export default "__VITE_ASSET__Bu75PURA__"